export interface ICatalogoDto {
  id?: string;
  nombre?: string;
}

export class CatalogoDto implements ICatalogoDto {
  constructor(public id?: string, public nombre?: string) {}
}
